interface KolTagOption {
  text: string;
  value: string;
}

export const splitKey = '&';
const othersValue = `active${splitKey}potential${splitKey}core${splitKey}multi-gamer${splitKey}not-tag`;

const KOL_TAGS_MAP: Record<string, KolTagOption[]> = {
  u10000000022: [
    { text: 'Partnered', value: 'partnered' },
    { text: 'Third Party', value: 'third-party' },
    { text: 'Others', value: othersValue },
  ],
  default: [
    { text: 'Partnered', value: 'partnered' },
    { text: 'Creator Hub Incentive', value: 'creatorhub' },
    { text: 'Others', value: othersValue },
  ],
};

export const kolTagsOptions = (gameInfo: any): KolTagOption[] =>
  KOL_TAGS_MAP[gameInfo?.edition_unified_id] || KOL_TAGS_MAP.default;
